import React from "react";
import "../css/base.css";
const Basefooter = () => (
  <div className="footer">
    <footer>
      <div className="contactus">
        <h1 className="contactusheading">Feel free to contact us</h1>
        <button className="contact-btn">ContactUs</button>
        <h5 className="footer-copyright">
          All Copyright of the website are reserved
        </h5>
      </div>
    </footer>
  </div>
);

export default Basefooter;
